import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';
import { Store } from '@ngrx/store';
import { filter, map } from 'rxjs/operators';

import { profileFeature } from '../redux/reducers/profile.reducers';

export const hasAccessGuard: CanActivateFn = () => {
  const store = inject(Store);
  const router = inject(Router);

  return store.select(profileFeature.selectProfiles).pipe(
    filter(profiles => profiles !== null),
    map(profiles => profiles.length > 0 || router.createUrlTree(['/no-access'])),
  );
};
